import parseISO from 'date-fns/parseISO';

import { ISO_LOCAL_DATE, ISO_LOCAL_DATE_TIME } from './constants';
import { parse } from './mixins';

export const parseIsoLocalDateTime = (
	dateString: string | undefined,
	defaultValue: Date,
	timezoneOffset?: number,
): Date => {
	if (dateString) {
		let date = parse(dateString, ISO_LOCAL_DATE_TIME, defaultValue);

		// Used to shift dates back to UTC time (parse will automatically add the user's timezone to dates)
		if (date && timezoneOffset) {
			date = new Date(date.valueOf() + timezoneOffset);
		}

		if (!date || isNaN(date.getTime())) {
			date = parseISO(dateString);
		}

		if (!date || isNaN(date.getTime())) {
			date = defaultValue;
		}

		return date;
	} else {
		return defaultValue;
	}
};

/**
 * Parses a date value string into a Date at local midnight for that calendar day.
 * Accepts "YYYY-MM-DD" or an ISO string (only the first 10 characters are used).
 * Uses local-time parsing so that e.g. "2024-01-15" is January 15 in the user's
 * timezone. Parsing as UTC midnight would make it January 14 in timezones behind UTC.
 */
export function parseValueToLocalDate(value: string): Date {
	const datePart = value.slice(0, 10);
	// Reference date only; result must stay in the viewer's local calendar, not workspace TZ.
	// eslint-disable-next-line @townsquare/rules/prefer-tzdate-instead
	return parse(datePart, ISO_LOCAL_DATE, new Date());
}
